import request from '@/utils/request'

// 查询
export function fetchList (data) {
  return request.post('/system/dictData/page', data)
}

// 根据字典编码查询
export function findByDictCode (data) {
  return request.cache('DICT_DATA_LIST_' + data.dictCode).get('/system/dictData/findByDictCode', {
    params: data
  })
}

// 排序
export function sort (data) {
  return request.post('/system/dictData/sort', data)
}

// 新建
export function create (data) {
  return request.post('/system/dictData/create', data)
}

// 修改
export function updateById (data) {
  return request.post('/system/dictData/updateById', data)
}

// 删除
export function deleteById (id) {
  return request.get(`/system/dictData/delete/${id}`)
}

// 批量删除
export function deleteByIdInBatch (ids) {
  return request.get('/system/dictData/delete/batch', {
    params: {
      ids
    }
  })
}
